import { render } from "./AutoBidCompletedPurchasesPage.vue?vue&type=template&id=1c25c0ea"
import script from "./AutoBidCompletedPurchasesPage.vue?vue&type=script&lang=js"
export * from "./AutoBidCompletedPurchasesPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__